import styled from 'styled-components';
import { Tabs } from 'antd';
import theme from '../../../styles/defaultTheme';

const { TabPane } = Tabs;

export const StyledTabs = styled(Tabs)`
  & .ant-tabs-tab:not(.ant-tabs-tab-active) {
    color: ${(props) => props.theme.greyLink};
  }
  
  & .ant-tabs-tab-btn {
    font-weight: bold;
    font-size: ${theme.font.size24};
    
    &:hover, &:focus {
      color: inherit;
    }
  }

  & .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.black};
  }

  & .ant-tabs-ink-bar {
    background: ${(props) => props.theme.orange} !important;
  }
`;

export const StyledTabPane = styled(TabPane)`
  color: ${(props) => props.theme.blackLink};
`;
